<sub-header [isModal]="true" [windowHash]=windowHash [includeContextHelp]="false"></sub-header>
<p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1">
  <div class="container-fluid">
    <!--  -->
    <div class="row">
      <div class="col-12">
        <form role="form" #element>
          <p-toolbar>
            <div class="ui-toolbar-group-left" *ngIf="pdf">
              <button #elementChild (click)="incrementPage(-1)" class="btn btn-white" [disabled]="initPage()"
                title="{{ 'FilePDFViewer.pagedown' | translate }}" type="button">
                <!--i	class="far fa-file d-none d-md-inline-block"></i--> <i class="fa fa-chevron-up"></i>
              </button>
              <label class="mdl-textfield__label d-none d-md-inline-block" for="pdf-page">{{ 'FilePDFViewer.page' |
                translate }}</label>
              <input #elementChild [(ngModel)]="page" [value]="page" style="vertical-align: middle;" type="number"
                pattern="-?[0-9]*(\.[0-9]+)?" id="pdf-page" name="pdf-page" min="1" max="{{ pdf.numPages }}">
              <span *ngIf="pdf" class="hidden-xs" style="vertical-align: middle;">/{{ pdf.numPages }}</span>
              <button #elementChild (click)="incrementPage(1)" class="btn btn-white" [disabled]="lastPage()"
                title="{{ 'FilePDFViewer.pageup' | translate }}" type="button">
                <!--i	class="far fa-file d-sm-none d-md-inline"></i-->
                <i class="fa fa-chevron-down"></i>
              </button>
            </div>
            <div class="ui-toolbar-group-right">
              <!--button *ngIf="showExpandButton && props.value.showExpanded" (click)="toogleShowInfo()" class="btn btn-info m-l-sm"><i class="fa fa-info-circle"></i></button-->
              <button #elementChild (click)="incrementZoom(-0.1)" class="btn btn-white m-l-sm"
                title="{{ 'FilePDFViewer.zoomout' | translate }}" type="button"><i
                  class="fas fa-search-minus"></i></button>
              <button #elementChild (click)="incrementZoom(0.1)" class="btn btn-white"
                title="{{ 'FilePDFViewer.zoomin' | translate }}" type="button"><i
                  class="fas fa-search-plus"></i></button>
              <button #elementChild (click)="rotate(-90)" class="btn btn-white d-none d-md-inline-block m-l-sm"
                title="{{ 'FilePDFViewer.rotateleft' | translate }}" type="button"><i
                  class="fa fa-rotate-left"></i></button>
              <button #elementChild (click)="rotate(90)" class="btn btn-white d-none d-md-inline-block"
                title="{{ 'FilePDFViewer.rotateright' | translate }}" type="button"><i
                  class="fa fa-rotate-right"></i></button>
            </div>
          </p-toolbar>
        </form>
      </div>
    </div>
    <div class="row ">
      <div class="col-12">
        <p-panel class=" d-block">
          <pdf-viewer #viewer (after-load-complete)="afterLoadComplete($event)" [page]="page" [zoom]="zoom"
            [show-all]="true" [autoresize]="true" [rotation]="rotation" [src]="pdfSrc" [fit-to-page]="true"
            class="nosafari-wrapper">
          </pdf-viewer>
        </p-panel>
      </div>
    </div>
  </div>
</p-scrollPanel>